import { render, staticRenderFns } from "./symbol_page.vue?vue&type=template&id=1e51f15a"
import script from "./symbol_page.vue?vue&type=script&lang=js"
export * from "./symbol_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports